// utils.ts (o cualquier archivo de utilidades)
import { pageDefaultHeight, pageDefaultWidth } from 'utils/constants/pageConstants';

export const getPageOrientation = (
  isOrientedHorizontally: boolean | undefined,
  isOrientedHorizontallySinglePage: boolean | undefined
) => {
  if (isOrientedHorizontally) {
    return {
      minHeight: pageDefaultWidth,
      width: pageDefaultHeight,
    };
  }
  return isOrientedHorizontallySinglePage
    ? {
        minHeight: pageDefaultWidth,
        width: pageDefaultHeight,
      }
    : {
        minHeight: pageDefaultHeight,
        width: pageDefaultWidth,
      };
};
